import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// The production build aliases Firebase modules to local adapters.
// With REACT_APP_STORAGE_MODE=drive, app data is saved in Google Drive.
const firebaseConfig = {
  name: 'ybit-google-drive-app'
};

// Initialize the local compatibility adapters.
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Backend API URL
// In development: uses localhost:3001
// Offline build: browser fetch handlers answer these API calls locally.
const getDefaultBackendUrl = () => {
  if (typeof window !== 'undefined' && !['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return window.location.origin;
  }

  return 'http://localhost:3001';
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || getDefaultBackendUrl();

console.log('🔗 Backend URL:', BACKEND_URL);

export default app;
